import { useCalendarStore } from "../../store/useCalendarStore";
import dayjs from "dayjs";
import {
  returnHeightOfEventBlock,
  returnYoffsetForEvent,
} from "@/utils/appointment-utils";

const ShiftBlock = ({ shift, date }) => {
  const { calendarData } = useCalendarStore((state) => state);

  const locationStart = dayjs(`${date}T${calendarData.startTime}`);
  const locationEnd = dayjs(`${date}T${calendarData.endTime}`);

  const shiftStart = (() => {
    if (dayjs(shift.start).isBefore(locationStart)) {
      return locationStart;
    }
    return dayjs(shift.start);
  })();

  const shiftEnd = (() => {
    if (dayjs(shift.end).isAfter(locationEnd)) {
      return locationEnd;
    }
    return dayjs(shift.end);
  })();

  const yOffset = returnYoffsetForEvent({
    calendarStartTime: calendarData.startTime,
    startTimeEvent: shiftStart,
    timeStep: calendarData.timeStep,
    slotHeight: calendarData.slotHeight,
  });

  const height = returnHeightOfEventBlock({
    duration: shiftEnd.diff(shiftStart, "minute"),
    timeStep: calendarData.timeStep,
    slotHeight: calendarData.slotHeight,
  });

  return (
    <div
      className="absolute -z-1 rounded-[6px] border-2 border-dashed border-[#74b587] bg-[#f1fcf1] dark:bg-neutral-700"
      style={{
        width: `calc(100% - 5px)`,
        top: `calc(${yOffset}px + (5px / 2))`,
        height: `max(calc(${height}px - 5px), 0px)`,
        left: `calc(5px / 2)`,
        pointerEvents: "none",
      }}
    />
  );
};

export default ShiftBlock;
